// extracted by mini-css-extract-plugin
export default {"container":"page-dashboard-v2_container__CX8Xs","loader":"page-dashboard-v2_loader__X3Gz5","tabContainer":"page-dashboard-v2_tabContainer__Cro9d"};